import React, { Component } from 'react';
import ReactDOM from 'react-dom';
/* Components */

class ModalFaults extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        data-close="ok"
        onClick={this.props.handleModal}
        className={this.props.modal ? `container-modal faults-detail-container-modal` 
          : `container-modal faults-detail-container-modal hide`}
      >
        <section className="module-title modal-title">
          <h2>
            {this.props.language.summary.ffdPvt.lastDataView.rejectReason + ": "}
            {this.props.faultTitle ? this.props.faultTitle : ""}
          </h2>
          <a>
            <i data-close="ok" onClick={this.props.handleModal} className="fas fa-times-circle" />
          </a>
        </section>
        {this.props.htmlDetail != null && (
          <div className="box-modal max500">
            <div 
              className="htmlDetail" 
              dangerouslySetInnerHTML={{__html: this.props.htmlDetail}}
            >
            </div>
          </div>
        )}
        <div className={'box-form islabel top center modal-button-box'}>
        </div>
      </div>
    );
  }
}

export default ModalFaults;



// WEBPACK FOOTER //
// ./source/client/components/last_data_ffd_pvt/modalFaults.jsx